"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvalidFieldTypeMessage = exports.propertyIsNotNil = exports.getFieldValue = exports.isKeyOfConcentrationLimitFields = exports.isCalcPropertyKey = exports.toLowerIfString = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const getValue_1 = require("../getValue");
const toLowerIfString = (value) => _.isString(value) ? _.toLower(value) : value;
exports.toLowerIfString = toLowerIfString;
const isCalcPropertyKey = (field) => [
    'concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts',
    'eligibilityFields.eligibleExposure',
].includes(field);
exports.isCalcPropertyKey = isCalcPropertyKey;
const isKeyOfConcentrationLimitFields = (test) => {
    const values = [
        'loanProductId',
        'concentrationLimitFields',
        'eligibilityFields',
        'valuationFields',
        'postProcessedFields',
        'requiredIntermediateFields',
        'dynamicIntermediateFields',
        'baseFields',
    ];
    return values.includes(test);
};
exports.isKeyOfConcentrationLimitFields = isKeyOfConcentrationLimitFields;
const getFieldValue = ({ loanTape, field, }) => {
    // we expect the field to be of "a.b" format.
    // or it could be 'loanProductId'
    const [concentrationLimitPropertyGroup, concentrationLimitProperty,] = field.split('.');
    (0, common_1.finleyAssert)((0, exports.isKeyOfConcentrationLimitFields)(concentrationLimitPropertyGroup), `Invalid concentrationLimitPropertyGroup = [${concentrationLimitPropertyGroup}]`);
    return (0, getValue_1.getValue)({
        fields: loanTape,
        concentrationLimitPropertyGroup,
        concentrationLimitProperty,
    });
};
exports.getFieldValue = getFieldValue;
const propertyIsNotNil = (field) => {
    return (loanTape) => !_.isNil((0, exports.getFieldValue)({ loanTape, field }));
};
exports.propertyIsNotNil = propertyIsNotNil;
const getInvalidFieldTypeMessage = ({ field, type, invalidRecord, operationType, }) => {
    return `Concentration calcs [${operationType} operation]: Invalid [type ${type}] for [field ${String(field)}] for [external receivable ID ${invalidRecord?.externalReceivableId}]`;
};
exports.getInvalidFieldTypeMessage = getInvalidFieldTypeMessage;
//# sourceMappingURL=utils.js.map